class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.announcement = this.querySelector('[data-cart-announcement]');
    this.pointerWithin = false;

    this.notification.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'touch') return;
      this.pointerWithin = true;
      clearTimeout(this.closeTimer);
    });
    this.notification.addEventListener('pointerleave', () => {
      this.pointerWithin = false;
      this.scheduleClose();
    });
    this.notification.addEventListener('focusin', () => clearTimeout(this.closeTimer));
    this.notification.addEventListener('focusout', () => {
      clearTimeout(this.focusOutTimer);
      this.focusOutTimer = setTimeout(() => this.scheduleClose(), 0);
    });
    this.onEscape = (event) => {
      if (event.key === 'Escape' && this.notification.classList.contains('active')) this.close();
    };
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  connectedCallback() {
    this.onPageShow = (event) => {
      if (!event.persisted) return;
      fetch(`${routes.cart_url}?sections=cart-icon-bubble`, { cache: 'no-store' })
        .then((response) => response.json())
        .then((sections) => {
          const markup = sections['cart-icon-bubble'];
          const source = markup && new DOMParser().parseFromString(markup, 'text/html').querySelector('.shopify-section');
          const target = document.getElementById('cart-icon-bubble');
          if (target && source) target.innerHTML = source.innerHTML;
        }).catch(console.error);
    };
    window.addEventListener('pageshow', this.onPageShow);
    document.addEventListener('keydown', this.onEscape);
  }

  disconnectedCallback() {
    window.removeEventListener('pageshow', this.onPageShow);
    document.removeEventListener('keydown', this.onEscape);
    document.body.removeEventListener('click', this.onBodyClick);
    clearTimeout(this.closeTimer);
    clearTimeout(this.focusOutTimer);
    cancelAnimationFrame(this.announcementFrame);
  }

  open() {
    this.notification.classList.add('animate', 'active');
    if (typeof this.notification.showPopover === 'function' && !this.notification.matches(':popover-open')) {
      this.notification.showPopover();
    }
    if (this.announcement) {
      this.announcement.textContent = '';
      cancelAnimationFrame(this.announcementFrame);
      this.announcementFrame = requestAnimationFrame(() => {
        const heading = this.notification.querySelector('.cart-notification__heading')?.textContent.trim();
        const product = this.notification.querySelector('.cart-notification-product__name')?.textContent.trim();
        this.announcement.textContent = [heading, product].filter(Boolean).join('. ');
      });
    }
    document.body.addEventListener('click', this.onBodyClick);
    this.scheduleClose();
  }

  scheduleClose() {
    clearTimeout(this.closeTimer);
    if (!this.notification.classList.contains('active') || this.pointerWithin ||
        this.notification.contains(document.activeElement)) return;
    this.closeTimer = setTimeout(() => this.close(), 4500);
  }

  close() {
    clearTimeout(this.closeTimer);
    const restoreFocus = this.notification.contains(document.activeElement);
    this.notification.classList.remove('active');
    if (typeof this.notification.hidePopover === 'function' && this.notification.matches(':popover-open')) {
      this.notification.hidePopover();
    }
    this.pointerWithin = false;
    document.body.removeEventListener('click', this.onBodyClick);
    if (restoreFocus && this.activeElement?.isConnected) this.activeElement.focus({ preventScroll: true });
  }

  renderContents(parsedState) {
    let complete = true;
    this.cartItemKey = parsedState.key || parsedState.items?.[0]?.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const markup = parsedState.sections?.[section.id];
      if (!target) return;
      if (!markup) { complete = false; return; }
      const html = new DOMParser().parseFromString(markup, 'text/html');
      const source = html.querySelector(section.selector || '.shopify-section') ||
        (section.id === 'cart-notification-product' &&
          html.querySelector(`[id^="cart-notification-product-${parsedState.variant_id || parsedState.id || parsedState.items?.[0]?.variant_id}:"]`));
      if (source) target.innerHTML = source.innerHTML;
      else complete = false;
    });

    if (complete) this.open();
    return complete;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
